import { render, staticRenderFns } from "./CodeVerificationInputs.vue?vue&type=template&id=cdd83da4&scoped=true&"
import script from "./CodeVerificationInputs.vue?vue&type=script&lang=js&"
export * from "./CodeVerificationInputs.vue?vue&type=script&lang=js&"
import style0 from "./CodeVerificationInputs.vue?vue&type=style&index=0&id=cdd83da4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd83da4",
  null
  
)

export default component.exports